import React from 'react';
import { safeLocalFormat } from '../../../utilities/functions';

const CheckoutDate = ({ row }) => {
  return <div>{row.checkOutDate ? safeLocalFormat(row.checkOutDate) : ""}</div>;
};

export default CheckoutDate;
